import React, { FC } from "react";
import { useContextPanel } from "@cayo/shared/hooks/useContextPanel";
import Panel from "../Surfaces/Panel";

const ContextPanelHolder: FC = () => {
  const { contextPanel } = useContextPanel();

  return (
    <>
      {contextPanel && (
        // eslint-disable-next-line no-inline-styles/no-inline-styles
        <Panel {...contextPanel} style={{ ...(contextPanel?.style || {}), overflowX: "hidden" }} />
      )}
    </>
  );
};

export default ContextPanelHolder;
